import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="mobile-scroll" style={{height:'auto'}}>
                                                <div className="innovativeimg image-bg3">
                                                    <div className="text-area3">
                                                        <input type="text"
                                                               className="star-text"
                                                               name="input"
                                                               tag="20"
                                                               value={this.props.pageData?.Manager3?.input}
                                                               onChange={this.props.handleChangePageData('Manager3')}/>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now you know what effective and consistent delivery of tasks and
                                                projects involves, here are
                                                suggestions about what to do next (although this list is by no
                                                means exhaustive).</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to ask for formal or informal feedback, to
                                                understand how other people
                                                perceive you and get advice about where you can make
                                                modifications or improvements. You can
                                                also use this information to manage people’s future expectations
                                                about your approach and ability
                                                to deliver. </p>
                                            <div className="border_subtitle">Consider your role model</div>
                                            <p>Try and identify someone you know who you admire for their
                                                delivery. Think about what it is
                                                you admire about their approach. This is the starting point for
                                                you to develop a plan to improve
                                                – see below.</p>
                                            <div className="border_subtitle">Discuss delivery style with
                                                someone
                                            </div>
                                            <p>Talk about your delivery style with someone you trust, such as
                                                your line manager, mentor, coach
                                                or colleague. Think about what you want from this person – do
                                                you want a sounding board? Do
                                                you want advice and guidance or do you want someone to help
                                                review and check your progress?</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use this tool to write out a personal, focused development
                                                plan.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Watch out for opportunities in your current work or elsewhere,
                                                where you can study the kind of
                                                methods you admire.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page8')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}